export default {
  state: {
    logsFilters: "",
  },

  getters: {
    getLogsFilters: (state) => state.logsFilters,
  },

  mutations: {
    setLogsFilters(state, filters) {
      state.logsFilters = filters;
    },
  },

  actions: {
    changeLogsFilters(context, filters) {
      context.commit("setLogsFilters", filters);
    },
  },
};
